import api from '@/utils/api'
import store from '@/store'

export const fetchRunners = (params) => {
  return api.get('/runners/', {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const fetchSimpleAdminRunners = (params) => {
  return api.get(`/runners/simple/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}

export const getRunner = (runnerId) => {
  if (store.getters.isTrainer) {
    return _getTrainersRunner(store.getters.authUser.id, runnerId)
  } else {
    return _getRunner(runnerId)
  }
}

export const getRunnerDataTrainer = (id) => {
  return api.get(`/runners/${id}/application_trainer/`)
    .then(resp => {
      return (resp.data)
    })
}
export const getRunnerDataPackage = (id) => {
  return api.get(`/runners/${id}/application_package/`)
    .then(resp => {
      return (resp.data)
    })
}
export const getRunnerData1 = (id) => {
  return api.get(`/runners/${id}/application1/`)
    .then(resp => {
      return (resp.data)
    })
}
export const getRunnerData2 = (id) => {
  return api.get(`/runners/${id}/application2/`)
    .then(resp => {
      return (resp.data)
    })
}
export const registerRunnerAdmin = (obj) => {
  return api.post('/users/registration/runner/', obj)
    .then(resp => {
      return (resp.data)
    })
}

export const updateRunner = (obj) => {
  var fd = new FormData()
  for (const [key, value] of Object.entries(obj)) {
    if (key === 'avatar_thumbnail' && !(value instanceof File)) {
      continue
    }
    if (value === null) {
      continue
    }
    fd.append(key, value)
  }
  return api.put(`/runners/${obj.id}/`, fd)
    .then(resp => {
      return (resp.data)
    })
}

export const updateRunnerData = (obj) => {
  var fd = new FormData()
  for (const [key, value] of Object.entries(obj)) {
    if (key === 'avatar_thumbnail' && !(value instanceof File)) {
      continue
    }
    if (value === null) {
      continue
    }
    fd.append(key, value)
  }
  return api.put(`/runners/${obj.id}/data/`, fd)
    .then(resp => {
      return (resp.data)
    })
}

export const updateRunnerDataPackage = (id, obj) => {
  return api.put(`/runners/${id}/application_package/`, obj)
    .then(resp => {
      return (resp.data)
    })
}
export const updateRunnerDataTrainer = (id, obj) => {
  return api.put(`/runners/${id}/application_trainer/`, obj)
    .then(resp => {
      return (resp.data)
    })
}
export const updateRunnerData1 = (id, obj) => {
  return api.put(`/runners/${id}/application1/`, obj)
    .then(resp => {
      return (resp.data)
    })
}
export const updateRunnerData2 = (id, obj) => {
  return api.put(`/runners/${id}/application2/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const patchRunner = (obj) => {
  return api.patch(`/runners/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const activateRunner = (obj) => {
  return api.patch(`/runners/${obj.id}/`, {is_active: true})
    .then(resp => {
      return (resp.data)
    })
}
export const deactivateRunner = (obj) => {
  return api.patch(`/runners/${obj.id}/`, {is_active: false})
    .then(resp => {
      return (resp.data)
    })
}
export const sendMailRunner = (obj) => {
  return api.post(`/runners/${obj.id}/resend_email/`, {})
    .then(resp => {
      return (resp.data)
    })
}

// zawodnicy trenera
export const fetchTrainerRunners = (trainerId, params) => {
  return api.get(`/trainers/${trainerId}/runners/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const fetchSimpleTrainerRunners = (trainerId, params) => {
  return api.get(`/trainers/${trainerId}/runners/simple/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const updateRunnerTrainer = (trainerId, obj) => {
  return api.put(`/trainers/${trainerId}/runners/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}
export const patchRunnerTrainer = (trainerId, obj) => {
  if (!trainerId) {
    return patchRunner(obj)
  }
  return api.patch(`/trainers/${trainerId}/runners/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}
const _getRunner = (id) => {
  return api.get(`/runners/${id}/`)
    .then(resp => {
      return (resp.data)
    })
}
const _getTrainersRunner = (trainerId, runnerId) => {
  return api.get(`/trainers/${trainerId}/runners/${runnerId}/`)
    .then(resp => {
      return (resp.data)
    })
}



// WEBPACK FOOTER //
// ./src/runners/api.js